"use strict";
import('./bootstrap').catch((err) => console.error(err));
